import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "serviceType",
    "subscriptionMode",
    "treatmentField",
    "creditField",
    "sessionsField",
    "installmentSection",
    "enableInstallments",
    "installmentFields",
    "tiersContainer",
    "installmentTiersJson"
  ]

  connect() {
    this.updateVisibility()
    this.tierCount = this.tiersContainerTarget.querySelectorAll('[data-tier-row]').length
  }

  // Helper pour obtenir la valeur d'un select (y compris les select_component cachés)
  getSelectValue(target) {
    // Si c'est un select natif, retourner directement sa valeur
    if (target.tagName === 'SELECT') {
      return target.value
    }
    // Sinon, chercher le select caché à l'intérieur (pour select_component)
    const hiddenSelect = target.querySelector('select')
    return hiddenSelect ? hiddenSelect.value : target.value
  }

  serviceTypeChanged() {
    this.updateVisibility()
  }

  modeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const serviceType = this.getSelectValue(this.serviceTypeTarget)
    const mode = this.getSelectValue(this.subscriptionModeTarget)

    // Afficher le champ traitement seulement pour treatments
    this.treatmentFieldTarget.style.display = serviceType === 'treatments' ? '' : 'none'

    // Afficher crédit ou séances selon le mode
    this.creditFieldTarget.style.display = mode === 'credit' ? '' : 'none'
    this.sessionsFieldTarget.style.display = mode === 'sessions' ? '' : 'none'

    // Section échelonnement seulement pour mode séances
    this.installmentSectionTarget.style.display = mode === 'sessions' ? '' : 'none'
  }

  toggleInstallments(event) {
    const enabled = event.target.checked
    this.installmentFieldsTarget.style.display = enabled ? '' : 'none'
    
    if (!enabled) {
      // Vider les tiers si désactivé
      this.installmentTiersJsonTarget.value = ''
    }
  }

  addTier() {
    this.tierCount++
    const inputClasses = "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-200 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-sz-primary-600 sm:text-sm/6"
    const tierHtml = `
      <div class="flex items-center gap-4 mb-3" data-tier-row>
        <span class="text-sm font-medium text-gray-500 w-20">Palier ${this.tierCount}</span>
        <div class="flex-1">
          <input type="number" name="installment_tiers[${this.tierCount - 1}][price]" 
                 placeholder="Prix €" 
                 step="0.01" min="0"
                 class="${inputClasses}">
        </div>
        <div class="flex-1">
          <input type="number" name="installment_tiers[${this.tierCount - 1}][sessions]" 
                 placeholder="Séances" 
                 min="1"
                 class="${inputClasses}">
        </div>
        <button type="button" data-action="subscription-plan-form#removeTier" 
                class="text-red-500 hover:text-red-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
      </div>
    `
    this.tiersContainerTarget.insertAdjacentHTML('beforeend', tierHtml)
  }

  removeTier(event) {
    const row = event.target.closest('[data-tier-row]')
    if (row) {
      row.remove()
      this.updateTierNumbers()
    }
  }

  updateTierNumbers() {
    const rows = this.tiersContainerTarget.querySelectorAll('[data-tier-row]')
    rows.forEach((row, index) => {
      const label = row.querySelector('span')
      if (label) {
        label.textContent = `Palier ${index + 1}`
      }
      // Mettre à jour les noms des inputs
      const inputs = row.querySelectorAll('input')
      inputs.forEach(input => {
        const name = input.name
        input.name = name.replace(/\[\d+\]/, `[${index}]`)
      })
    })
    this.tierCount = rows.length
  }
}
